<script>
import { layoutComputed } from '@/state/helpers';
import { SimpleBar } from 'simplebar-vue3';
import { fetchMenus } from '@/helpers/menuApi.js';
import axios from 'axios';

export default {
  components: {
    SimpleBar
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      menuLoading: true,
      // menus: ,
    };
  },
  computed: {
    ...layoutComputed,
    layoutType: {
      get() {
        return this.$store ? this.$store.state.layout.layoutType : {};
      },
    },
    menus() {
      return this.$store.state.menus;
    }
  },
  watch: {
    $route: {
      handler: 'onRoutechange',
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async loadMenu() {
      // 1. Load from cache immediately for instant display
      this.$store.commit('getMenus');

      // If stored menus contain anomalous duplicate parent-child names (e.g. CRM submenus named CRM),
      // invalidate cache so fresh menus are loaded immediately
      const cachedMenus = this.$store.state.menus || [];
      const hasDuplicateSubmenuNames = cachedMenus.some(
        (m) => Array.isArray(m?.children) && m.children.some((c) => c?.name && m?.name && c.name === m.name)
      );
      if (hasDuplicateSubmenuNames) {
        window.menuVersionChecked = false;
        localStorage.removeItem('menuVersion');
      }

      // 2. Avoid calling the API on every internal route change (SPA "refresh")
      // only trigger on actual browser reload (F5) or new tab
      if (window.menuVersionChecked) {
        window.menuDataReady = true;
        window.dispatchEvent(new CustomEvent('app:menus-ready'));
        return;
      }

      try {
        // 3. Perform the version check
        const response = await axios.get(`${process.env.VUE_APP_AUTHDOMAIN}/api/v1/me/menu`, {
          params: {
            version: true,
          },
        });
        const version = response.data.data;

        // Mark as checked in the current JS session
        window.menuVersionChecked = true;

        // 4. Only fetch full menu if the version in storage is different or cache has duplicate names
        const hasStoredMenu = localStorage.getItem('storedMenu') && localStorage.getItem('storedMenu').length > 0;
        if (!hasStoredMenu || localStorage.getItem('menuVersion') !== version || hasDuplicateSubmenuNames) {
          await fetchMenus();
        } else {
          window.menuDataReady = true;
          window.dispatchEvent(new CustomEvent('app:menus-ready'));
        }
      } catch (error) {
        console.error('Failed to fetch menu version:', error);
        window.menuDataReady = true;
        window.dispatchEvent(new CustomEvent('app:menus-ready'));
      }
    },
    onRoutechange(ele) {
      this.initActiveMenu(ele.path);
      if (document.getElementsByClassName('mm-active').length > 0) {
        const currentPosition = document.getElementsByClassName('mm-active')[0].offsetTop;
        if (currentPosition > 500)
          if (this.$refs.isSimplebar)
            this.$refs.isSimplebar.value.getScrollElement().scrollTop = currentPosition + 300;
      }
    },
    initActiveMenu(ele) {
      setTimeout(() => {
        if (document.querySelector('#navbar-nav')) {
          let a = document.querySelector('#navbar-nav').querySelector('[href="' + ele + '"]');
          if (a) {
            a.classList.add('active');
            let parentCollapseDiv = a.closest('.collapse.menu-dropdown');
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add('show');
              parentCollapseDiv.parentElement.children[0].classList.add('active');
              parentCollapseDiv.parentElement.children[0].setAttribute('aria-expanded', 'true');
              if (parentCollapseDiv.parentElement.closest('.collapse.menu-dropdown')) {
                parentCollapseDiv.parentElement.closest('.collapse').classList.add('show');
                if (parentCollapseDiv.parentElement.closest('.collapse').previousElementSibling)
                  parentCollapseDiv.parentElement.closest('.collapse').previousElementSibling.classList.add('active');
                const grandparent = parentCollapseDiv.parentElement.closest('.collapse').previousElementSibling.parentElement.closest('.collapse');
                if (grandparent && grandparent.previousElementSibling) {
                  grandparent.previousElementSibling.classList.add('active');
                  grandparent.classList.add('show');
                }
              }
            }
          }
        }
      }, 0);
    },
    routerLink(menu) {
      const target = String(menu?.url || '').trim();
      if (!target) return '/';

      // Vue Router resolves paths without a leading slash relative to the
      // current route. Menu URLs must always navigate from the app root, even
      // when the user is on a deeply nested entry page.
      return target.startsWith('/') ? target : `/${target}`;
    }
  },
  created() {
    
  },
  async mounted() {
    const loadingFailsafe = setTimeout(() => {
      this.menuLoading = false;
    }, 9000);

    try {
      await this.loadMenu();
    } finally {
      clearTimeout(loadingFailsafe);
      this.menuLoading = false;
    }
    await this.$nextTick();
    if (document.querySelectorAll('.navbar-nav .collapse')) {
      let collapses = document.querySelectorAll('.navbar-nav .collapse');

      collapses.forEach((collapse) => {
        // Hide sibling collapses on `show.bs.collapse`
        collapse.addEventListener('show.bs.collapse', (e) => {
          e.stopPropagation();
          let closestCollapse = collapse.parentElement.closest('.collapse');
          if (closestCollapse) {
            let siblingCollapses =
							closestCollapse.querySelectorAll('.collapse');
            siblingCollapses.forEach((siblingCollapse) => {
              if (siblingCollapse.classList.contains('show')) {
                siblingCollapse.classList.remove('show');
                siblingCollapse.parentElement.firstChild.setAttribute('aria-expanded', 'false');
              }
            });
          } else {
            let getSiblings = (elem) => {
              // Setup siblings array and get the first sibling
              let siblings = [];
              let sibling = elem.parentNode.firstChild;
              // Loop through each sibling and push to the array
              while (sibling) {
                if (sibling.nodeType === 1 && sibling !== elem) {
                  siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
              }
              return siblings;
            };

            let siblings = getSiblings(collapse.parentElement);
            siblings.forEach((item) => {
              if (item.childNodes.length > 2) {
                item.firstElementChild.setAttribute('aria-expanded', 'false');
                item.firstElementChild.classList.remove('active');
              }
              let ids = item.querySelectorAll('*[id]');
              ids.forEach((item1) => {
                item1.classList.remove('show');
                item1.parentElement.firstChild.setAttribute('aria-expanded', 'false');
                item1.parentElement.firstChild.classList.remove('active');
                if (item1.childNodes.length > 2) {
                  let val = item1.querySelectorAll('ul li a');

                  val.forEach((subitem) => {
                    if (subitem.hasAttribute('aria-expanded'))
                      subitem.setAttribute('aria-expanded', 'false');
                  });
                }
              });
            });
          }
        });

        // Hide nested collapses on `hide.bs.collapse`
        collapse.addEventListener('hide.bs.collapse', (e) => {
          e.stopPropagation();
          let childCollapses = collapse.querySelectorAll('.collapse');
          childCollapses.forEach((childCollapse) => {
            let childCollapseInstance = childCollapse;
            childCollapseInstance.classList.remove('show');
            childCollapseInstance.parentElement.firstChild.setAttribute('aria-expanded', 'false');
          });
        });
      });
    }
  },
};
</script>

<template>
  <b-container fluid class="p-0">
    <div id="two-column-menu"></div>

		<div v-if="menuLoading" class="sidebar-menu-skeleton" role="status" aria-label="Loading navigation menu">
			<div class="sidebar-skeleton-label sidebar-shimmer"></div>
			<div v-for="item in 8" :key="item" class="sidebar-skeleton-row">
				<span class="sidebar-skeleton-icon sidebar-shimmer"></span>
				<span class="sidebar-skeleton-text sidebar-shimmer" :style="{ width: `${52 + (item % 4) * 9}%` }"></span>
			</div>
		</div>

		<template v-else-if="layoutType === 'twocolumn'">
			<SimpleBar class="navbar-nav" id="navbar-nav">
				<li class="menu-title">
					<span data-key="t-menu"> {{ $t("t-menu") }}</span>
				</li>
				<li class="nav-item" v-for="(menu, index) in menus" :key="index">
					<b-link v-if="menu.child" class="nav-link menu-link" :href="'#menu'+index" data-bs-toggle="collapse" role="button"
						aria-expanded="false">
						<i v-if="menu.parent.icon" :class="menu.parent.icon"></i>
						<span> {{ $t(menu.parent.name) }}</span>
					</b-link>
					<div v-if="menu.child" class="collapse menu-dropdown" :id="'menu'+index">
						<ul class="nav nav-sm flex-column">
							<li class="nav-item" v-for="(child, i) in menu.child" :key="i">
								<router-link :to="child.url" class="nav-link custom-abc">
									{{ $t(child.name) }}
								</router-link>
							</li>
						</ul>
					</div>
					<div v-else>
						<router-link v-if="menu.parent.url" :to="menu.parent.url" class="nav-link custom-abc">
							<i v-if="menu.parent.icon" :class="menu.parent.icon"></i>
							<span> {{ $t(menu.parent.name) }}</span>
						</router-link>
						<router-link v-else href="javascript: void(0)" class="nav-link custom-abc">
							<i v-if="menu.parent.icon" :class="menu.parent.icon"></i>
							<span> {{ $t(menu.parent.name) }}</span>
						</router-link>
					</div>
				</li>
			</SimpleBar>
		</template>

		<template v-else>
			<ul class="navbar-nav h-100" id="navbar-nav">
				<li class="menu-title">
					<span data-key="t-menu"> {{ $t("t-menu") }}</span>
				</li>

				<template v-for="(menu, index) in menus" :key="index">
					<li v-if="!menu.children || menu.children.length === 0" class="nav-item">
						<router-link v-if="menu.url" :to="routerLink(menu)" class="nav-link" :data-key="menu.name">
							<i v-if="menu.icon" :class="menu.icon"></i>
							<span :data-key="menu.name"> {{ $t(menu.name) }}</span>
						</router-link>
					</li>
			
					<li v-else class="nav-item">
						<b-link 
							class="nav-link menu-link" 
							:href="'#menu'+index" 
							data-bs-toggle="collapse" 
							role="button"
							aria-expanded="false" 
							:aria-controls="'menu'+index"
						>
							<i v-if="menu.icon" :class="menu.icon"></i>
							<span :data-key="menu.name"> {{ $t(menu.name) }}</span>
						</b-link>

						<div class="collapse menu-dropdown" :id="'menu'+index">
							<ul class="nav nav-sm flex-column">
								<template v-for="(child, child_index) in menu.children" :key="child_index">

									<li v-if="!child.children || child.children.length === 0" class="nav-item">
										<router-link v-if="child.url" :to="routerLink(child)" class="nav-link" :data-key="child.name">
											{{ $t(child.name) }}
										</router-link>
									</li>
								
									<li v-else class="nav-item">
										<b-link
											:href="'#menu'+index+'_child'+child_index"
											class="nav-link"
											data-bs-toggle="collapse"
											role="button"
											aria-expanded="false" :aria-controls="'menu'+index+'_child'+child_index" :data-key="child.name"
										>
											{{ $t(child.name) }}
										</b-link>

										<div class="collapse menu-dropdown" :id="'menu'+index+'_child'+child_index">
											<ul class="nav nav-sm flex-column">
												<template v-for="(sub_child, sub_child_index) in child.children" :key="sub_child_index">
													<li v-if="!sub_child.children || sub_child.children.length === 0" class="nav-item">
														<router-link v-if="sub_child.url" :to="routerLink(sub_child)" class="nav-link" :data-key="sub_child.name">
															{{ $t(sub_child.name) }}
														</router-link>
													</li>

													<li v-else class="nav-item">
														<b-link
															:href="'#menu'+index+'_child'+child_index+'_sub'+sub_child_index"
															class="nav-link"
															data-bs-toggle="collapse"
															role="button"
															aria-expanded="false" :aria-controls="'menu'+index+'_child'+child_index+'_sub'+sub_child_index" :data-key="sub_child.name"
														>
															{{ $t(sub_child.name) }}
														</b-link>
														<div class="collapse menu-dropdown" :id="'menu'+index+'_child'+child_index+'_sub'+sub_child_index">
															<ul class="nav nav-sm flex-column">
																<li class="nav-item" v-for="(grand_child, grand_child_index) in sub_child.children" :key="grand_child_index">
																	<router-link v-if="grand_child.url" :to="routerLink(grand_child)" class="nav-link" :data-key="grand_child.name">
																		{{ $t(grand_child.name) }}
																	</router-link>
																</li>
															</ul>
														</div>
													</li>
												</template>
											</ul>
										</div>
									</li>
								</template> 
							</ul>
						</div>
					</li>
				</template> 
			</ul>
		</template>
	</b-container>
</template>

<style scoped>
.sidebar-menu-skeleton {
	padding: 1.2rem 0.65rem;
	pointer-events: none;
}

.sidebar-skeleton-label {
	width: 42px;
	height: 9px;
	margin: 0 0.75rem 1rem;
	border-radius: 999px;
}

.sidebar-skeleton-row {
	display: flex;
	align-items: center;
	gap: 0.8rem;
	height: 46px;
	padding: 0 0.7rem;
	margin-bottom: 0.2rem;
}

.sidebar-skeleton-icon {
	flex: 0 0 28px;
	width: 28px;
	height: 28px;
	border-radius: 8px;
}

.sidebar-skeleton-text {
	height: 11px;
	border-radius: 999px;
}

.sidebar-shimmer {
	display: block;
	background: linear-gradient(90deg, #eceff2 25%, #f8f9fa 50%, #eceff2 75%);
	background-size: 200% 100%;
	animation: sidebar-shimmer 1.35s ease-in-out infinite;
}

@keyframes sidebar-shimmer {
	from { background-position: 200% 0; }
	to { background-position: -200% 0; }
}
</style>
